module.exports = __webpack_public_path__ + "img/Facilitator test Learning Lab - Fr.9e199ae1.png";